function Toggler(el) {
  const targetId = el.getAttribute("data-target").replace("#", "");
  const targetEl = document.getElementById(targetId);
  const callbackFn = window[el.dataset.toggleCallback];
  const toggleGroupName = el.dataset.toggleGroup;
  const toggleGroup = document.querySelectorAll(`[data-toggle-group="${toggleGroupName}"]`);
  const toggleParentId = el.dataset.toggleParent;
  const toggleParent = document.getElementById(toggleParentId);

  // Only hide if not overriden
  if (targetEl.dataset.toggleShow !== "active") {
    targetEl.classList.add("hidden");
  }

  el.addEventListener("click", function () {
    // Hide other members of toggle group
    toggleGroup.forEach((item) => {
      if (item !== this) {
        const gTargetId = item.getAttribute("data-target").replace("#", "");
        const gTargetEl = document.getElementById(gTargetId);
        gTargetEl.classList.add("hidden");
      }
    });

    this.classList.toggle("active");
    targetEl.classList.toggle("hidden");

    if (toggleParent) {
      toggleParent.classList.toggle("active");
    }

    // Callback
    if (typeof callbackFn === "function") {
      callbackFn();
    }
  });
}

export function bindToggles() {
  return [...document.querySelectorAll("[data-toggle]")].map((el) => Toggler(el));
}
